// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a11y-check-btn .fa-universal-access {
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./Scripts/Shared/AccessibilityChecker/styles/A11yCheckButton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".a11y-check-btn .fa-universal-access {\r\n  font-size: 13px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
